/* eslint-disable max-len */

export default {
  lang: 'German',
  homeScreen: {
    title: 'The Theme Park Capital of the World',
    stayConnected: 'In Verbindung bleiben',
    comingSoon: 'Bald verfügbar',
    messages: 'Nachrichten',
  },
  notification: {
    newAndNow: 'Neu & Jetzt!',
    alert: 'Alarm',
    message: 'Nachricht',
    contest: 'Wettbewerb',
    badge: 'Neues Abzeichen',
    'content-update': 'Inhaltsaktualisierung',
    events: 'Veranstaltungen',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Schauen wir mal, ob wir in unserem System ein Profil für Sie finden können.',
      homeTitleSub:
        'Geben Sie die E-Mail-Adresse ein, die Sie normalerweise für die Anmeldung bei Schulungsprogrammen verwenden.',
      noAccount:
        'Kein Konto gefunden ({email}), bitte versuchen Sie es mit einer anderen E-Mail oder erstellen Sie jetzt ein Konto.',
      continueButton: 'Weiter',
      success:
        'Sie haben Ihr Konto erfolgreich aktualisiert! Sie werden in Kürze auf die Startseite weitergeleitet.',
      successNewAccount:
        'Um Ihre Anmeldung abzuschließen, erhalten Sie eine Bestätigungs-E-Mail, um Ihr Konto zu verifizieren.',
      loginButton: 'Anmeldung',
      matchFound:
        'Wir haben eine Übereinstimmung gefunden. Bitte geben Sie Ihr Passwort ein, um fortzufahren.',
      magicLink: 'Melden Sie sich über einen Link in Ihrer E-Mail an:',
      magicLinkButton: 'Magic Link anfordern',
      magicLinkTitle:
        'Lassen Sie sich einen direkten Link an Ihre E-Mail schicken, mit dem Sie sich sofort anmelden können.',
      otherEmailButton: 'Einreichen',
      title:
        'Bitte nehmen Sie sich einen Moment Zeit, um alle nachstehenden Informationen auszufüllen, da dadurch Ihr persönliches Profil und Ihre Kontaktinformationen erstellt werden.',
      titleIndustry:
        'Bitte nehmen Sie sich einen Moment Zeit, um alle nachstehenden Informationen auszufüllen, da dadurch Ihr persönliches Profil und Ihre Kontaktinformationen erstellt werden.',
      register: 'Ein Konto erstellen',
      agent: 'Reiseberater',
      visitor: 'Industrie Besucher',
      step1: 'Schritt 1: Art des Nutzers',
      step2: 'Schritt 2: Ein Konto erstellen',
      step3: 'Schritt 3: Erstellen Sie Ihr Profil',
      marketingOptIn:
        'Sind Sie sicher, dass Sie nicht daran interessiert sind, mit dem Travel Trade Team dieses Programms in Verbindung zu bleiben?',
      optIn: 'Ja, ich bin interessiert',
      optOut: 'Nicht Interessiert',
      step2Sub1: 'Erzählen Sie uns von sich selbst',
      step2Sub2: 'Erzählen Sie uns von Ihrem Unternehmen',
      privacyHead: 'KOMMUNIKATIONSPRÄFERENZEN',
      privacySub:
        'Kreuzen Sie die unten stehenden Kästchen an, um sicherzustellen, dass Sie wichtige Mitteilungen vom Reisebüroteam des Anbieters (Produktaktualisierungen und -ankündigungen, Prämien, Incentives, FAMs usw.) sowie Netzwerk- und Verkaufsförderungsinitiativen von TravPRO Mobile erhalten.',
      privacy:
        'Wir schützen Ihre Privatsphäre und verkaufen, missbrauchen oder betrügen niemals Ihr Vertrauen.',
      store:
        'Laden Sie dieses Programm ganz einfach in Ihrem App-Store herunter:',
      powered: 'ANGETRIEBEN DURCH',
      toastMessage: {
        forgotSuccess:
          'Wir haben Ihnen den Link zum Zurücksetzen Ihres Passworts per E-Mail geschickt! Sie werden in 10 Sekunden zur Login-Seite weitergeleitet.',
        emailNotExisting:
          'Die von Ihnen eingegebene E-Mail-Adresse existiert nicht.',
        magicLinkMessage: 'Bitte warten Sie, wir melden Sie gerade an.',
        magicLinkError:
          'Wir konnten Ihr Konto nicht in unserer Datenbank finden. Bitte melden Sie sich manuell an. Sie werden in 10 Sekunden weitergeleitet.',
        magicLinkError1:
          'Wir konnten keinen gültigen Token finden, bitte melden Sie sich an oder fordern Sie einen neuen magischen Link an.Wenn dieses Problem weiterhin besteht, kontaktieren Sie uns bitte unter: info@travpromobile.com.',
        magicLinkError2:
          'Wir konnten Ihr Konto nicht in unserer Datenbank finden. Bitte melden Sie sich manuell an.Sie werden in 10 Sekunden weitergeleitet.',
        magicLinkSuccess:
          'Prüfen Sie Ihre E-Mail an {email}.Sie enthält einen magischen Link, mit dem du dich anmelden kannst.',
        magicLinkErrorWait:
          'Bitte warten Sie 5 Minuten zwischen den Anfragen nach magischen Links.',
        emailNotFoundError:
          'Die von Ihnen eingegebene E-Mail-Adresse kann in unseren Unterlagen nicht gefunden werden. Bitte prüfen Sie auf Schreibfehler oder erstellen Sie ein Konto.',
      },
      errors: {
        zipCodeNotFound: 'ZipCode nicht gefunden, versuchen Sie es erneut',
        zipCodeOnlyNumbers: 'ZipCode kann nur Zahlen enthalten',
        password: 'Bitte geben Sie ein Passwort ein',
        passwordNotMatching:
          'Die von Ihnen eingegebenen Passwörter stimmen nicht überein',
        passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
        emailExists:
          'Diese E-Mail Adresse existiert bereits oder ist ungültig. Bitte versuchen Sie es mit einer anderen E-Mail-Adresse oder melden Sie sich bei Ihrem Konto an.',
        fillInAllFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
        fillInEmail: 'Bitte geben Sie Ihre E-Mail-Adresse an.',
        emailNotExisting:
          'Die von Ihnen eingegebene E-Mail-Adresse existiert nicht.',
      },
      fields: {
        forgotSubCopy:
          'Sie haben Ihr Passwort vergessen und möchten es ändern? ',
        forgotSubCopy2:
          'Möchten Sie das Passwort ganz umgehen? Wir schicken Ihnen eine E-Mail mit einem magischen Link, der Sie automatisch beim Programm anmeldet.',
        city: 'Stadt',
        companyName: 'Name des Unternehmens',
        role: 'Ihre Rolle',
        description:
          'Was beschreibt das Geschäft Ihres Unternehmens am besten?',
        country: 'Land',
        password: 'Passwort',
        passwordRegister: 'Passwort wählen (mindestens 8 Zeichen)',
        passwordConfirm: 'Bestätigen Sie Ihr Passwort',
        firstName: 'Vorname (gegeben)',
        lastName: 'Nachname (Familie)',
        agency: 'Name Ihrer Agentur',
        title: 'Ihre Rolle (Wählen Sie eine aus)',
        company: 'Name des Unternehmens',
        select: 'Wählen Sie unten eine Option',
        state: 'Staat',
        province: 'Bundesland/Region/Staat',
        zipCode: 'Postleitzahl',
        postalCode: 'Postleitzahl',
        affiliate: 'Welcher Gruppe gehören Sie in erster Linie an?',
        hostAgency: 'Ihre Aufnahmeagentur?',
        executive: 'Exekutive',
        management: 'Verwaltung',
        marketing: 'Marketing',
        sales: 'Vertrieb',
        coordinator: 'Koordinator',
        opt: 'Bleiben Sie mit dem Team dieses Programms in Verbindung und erhalten Sie aktuelle Informationen.',
        optMarketing:
          'Bleiben Sie mit TravPRO in Verbindung, wenn es um ähnliche Programme und Veranstaltungen geht.',
        retail: 'Einzelhandelsgeschäft Front',
        home: 'Home-Based Agent',
        independent: 'Unabhängiger Auftragnehmer',
        host: 'Gastgeber-Agentur',
        call: 'Call Center oder Web-basierte Agentur',
        other: 'Andere',
        describes:
          'Was beschreibt Sie und die Tätigkeit Ihrer Agentur am besten?',
      },
    },
    title: 'Schulung für Reiseexperten und Verkaufsschulungsprogramm',
    welcome: {
      headerTop: 'Willkommen in',
      headerBottom: 'Orlando Travel Academy',
    },
    sellingPoints: {
      0: 'Unterwegs lernen, bewerben und verkaufen',
      1: 'Multimedia-Schulung auf allen Geräten',
      2: 'Abschlusszertifikat',
      3: 'Vorgefertigte Verkaufspräsentationen',
      4: 'Wirkungsvolles Werbematerial',
      5: 'Insider-Tipps und Angebote',
      6: 'Echtzeit-Produktverzeichnis',
      7: 'Aktuelle Neuigkeiten und Updates',
    },
    emailPrompt:
      'Geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein, um zu bestätigen, dass Sie ein Reiseexperte sind.',
    tAndC: {
      agree: 'Wenn Sie fortfahren, akzeptieren Sie damit unsere ',
      privacyPolicy: 'Datenschutzrichtlinie',
      and: ' und ',
      termsConditions: 'Geschäftsbedingungen',
    },
    fields: {
      agency: 'Agentur',
      email: 'E-Mail-Adresse',
      password: 'Passwort',
      passwordConfirm: 'Bestätigen Sie Ihr Passwort *',
      firstName: 'Vorname *',
      lastName: 'Nachname *',
      city: 'Stadt *',
      agencyName: 'Agenturname *',
      stateProvince: 'Bundesland / Provinz *',
      required: 'Erforderlich',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      opt: 'Bleiben Sie in Kontakt! Ja, ich möchte mich für die Kommunikation von Orlando Travel Academy anmelden, die mich über Neuigkeiten, Veranstaltungen, Anreize, FAMs und mehr auf dem Laufenden hält!',
      complete: 'Schritt 2: Vervollständigen Sie Ihr Profil',
      tell: 'Erzählen Sie uns von sich',
      title: 'Geschäftstitel *',
      host: 'Gast-Agenturname',
      country: 'Land / Region',
      select: 'Bitte wählen Sie unten eine Option aus',
      header2: 'Welche Segmente verkaufen Sie hauptsächlich?',
      step2: 'Beschreiben Sie Ihr Geschäft',
      leisure: 'Freizeit',
      corporate: 'Corporate',
      group: 'Gruppe',
      affiliate: 'Was ist Ihre Hauptaffiliation?',
      forgot:
        'Haben Sie Ihr Passwort vergessen? Klicken Sie auf die Schaltfläche unten und wir senden Ihnen eine E-Mail, um Ihr Passwort zurückzusetzen.',
    },
    forgot: 'Passwort zurücksetzen',
    noAgent: {
      noAgentButton: 'Ich bin kein Berater',
      title: 'Vielen Dank für Ihr Interesse an der Orlando Travel Academy.',
      messageWeb:
        'Die Inhalte auf dieser Website sind exklusiv für Reiseexperten. \n Weitere Informationen zu Orland finden Sie unter: ',
      messageMobile:
        'Einige Inhalte in dieser App sind exklusiv für Reiseexperten, aber Sie können eine Vorschau anzeigen, was die App zu bieten hat. Drücken Sie dazu auf „Fortfahren“.',
      continue: 'Fortfahren',
      visitWebsite: 'Website besuchen',
    },
    newUser: 'Neuer Benutzer',
    register: 'Registrieren',
    registered: 'Diese E-Mail ist bereits registriert',
    forgot: 'Passwort vergessen',
    header:
      'Bitte nehmen Sie sich einen Moment Zeit, um alle Informationen unten auszufüllen, da dies Ihr Profil und Ihre Kontaktdaten ausfüllt.',
    step1:
      'Schritt 1: Geben Sie Ihre E-Mail-Adresse ein und wählen Sie ein Passwort.',
  },
  welcomeScreen: {
    title: 'Willkommen in der\nOrlando Travel Academy',
    helloUser: 'Hallo {{name}}',
    hello: 'Hallo,',
    fromAgency: 'von {{agency}}',
    notUser: 'Nicht {{name}}?',
    introOnline:
      'Führen Sie die Schulung direkt online durch, oder laden Sie den Inhalt, damit er zur Offline-Nutzung zur Verfügung steht!',
    introOffline:
      'Die aktuelle Version ist bereits geladen. Sie können jederzeit und überall mit der Schulung oder dem Verkauf beginnen!',
    startTraining: 'Jetzt lernen',
    continueTraining: 'Weiter lernen',
    graduated: 'Glückwunsch!',
    downloader: {
      preload: 'Laden',
      stop: 'anhalten',
      init: 'Wird initialisiert ...',
      lastUpdate: 'Letzte Aktualisierung: ',
    },
  },
  trainingScreens: {
    start: 'Starten',
    continue: 'Fortfahren',
    review: 'Prüfen',
    restart: 'Neu starten',
    durationInMinutes: '{number} Minuten',
    percentageComplete: '{number} % abgeschlossen',
    unlock:
      'Schalten Sie dieses Kapitel frei, indem Sie Schulungskapitel {number} abschließen.',
    unlockSubtitle:
      'Schalten Sie weitere Kapitel frei, indem Sie Schulungskapitel abschließen.',
    allUnlocked: 'Sie haben alle Kapitel freigeschaltet!',
    certificate: 'Zertifikat',
    courseComplete: 'Fortfahren',
    endReached: 'Sie haben das Ende erreicht',
    retainEnd:
      'Verwenden Sie die Leiste oben, um in diesem Kapitel zu navigieren, oder drücken Sie auf „Zurück“, um zur Übersicht zurückzukehren.',
    watchListenRead: 'Mehr ansehen, hören und lesen',
    trouble:
      'Offensichtlich haben Sie Schwierigkeiten. Gehen Sie die Inhalte der vorherigen Seite(n) erneut durch, und versuchen Sie es noch einmal.',
    confirm: 'Antwort bestätigen',
    choose: 'Antwort auswählen',
    skip: 'Zurückkehren &gt;',
    viewAllTitle: 'Schulungstipp',
    viewAll:
      'Um zur nächsten Seite zu gelangen, klicken Sie auf die Symbole, um die zusätzlichen Inhalte anzuzeigen. Videos, Karten und weitere nützliche Informationen werden bereitgestellt, um die Schulung zu verbessern und Sie zu einem echten Profi zu machen.',
    fillBlanks: 'Füllen Sie die Lücke(n):',
    next: 'Nächste Frage',
    retry: 'Erneut versuchen',
    fastTrackText: {
      success:
        'Glückwunsch, Sie haben den Schnellkurs bestanden und den Rest der Schulung freigeschaltet!',
      failed:
        'Leider haben Sie den Schnellkurs nicht bestanden. Sie können die Schulung fortsetzen, um Ihr Diplom zu erhalten!',
    },
    fastTrack: 'Werden Sie Schweizer Reiseexperte!',
    fastTrackExplanation:
      "Führen Sie einfach das Quiz auf den folgenden Seiten durch, um die Chance auf ein FAM für die Schweiz zu erhalten!<br><br><span style='font-weight: bold'>Alle Antworten auf die Quizfragen finden Sie in folgenden Quellen:</span><br><br>1.\tIn den Inhalten der Module zu Bahnreisen in Europa und der Schweiz<br><br>2.\tAuf den folgenden Websites:<br><a href='https://www.myswitzerland.com' target='_blank'>www.myswitzerland.com</a><br><a href='https://www.bucherer.com' target='_blank'>www.bucherer.com</a><br><a href='https://www.mysts.net' target='_blank'>www.mysts.net</a><br><br><span style='font-weight: bold'>Bevor Sie das Quiz durchführen, sollten Sie diese Ressourcen gründlich durchgelesen haben! Nur die Teilnehmer mit den besten Bewertungen haben die Chance, zum FAM eingeladen zu werden.</span>",
    fastTrackButton:
      'Klicken Sie hier, um das Quiz für Schweizer Reiseexperten durchzuführen',
    grading: 'Ihre Abschlussbewertung: {grade} %',
  },
  nav: {
    home: 'Startseite',
    train: 'Lernen',
    learn: 'Lernen',
    retain: 'Pflegen',
    directory: 'Verzeichnis',
    showRoom: 'Schaukästen',
    showcases: 'Schaukästen',
    offers: 'Angebote',
    promote: 'Bewerben',
    sell: 'Verkaufen',
    info: 'Info',
    rewards: 'Belohnungen',
    media: 'Medien',
    favorites: 'Favoriten',
    contact: 'Ansprechpartner',
    reportCard: 'Diplom anzeigen',
    accountSettings: 'Kontoeinstellungen',
    messages: 'Nachrichten',
    search: 'Suche',
  },
  contentHeaders: {
    train: 'Lernen',
    retain: 'Pflegen',
    subapps: 'Module für Orlando-Partner',
    maintrainings: 'Die Grundlage',
    subtrainings: 'Die Erfahrung',
    specializations: 'Zusatzqualifikationen',
  },
  pageDescriptions: {
    specializations:
      'Bringen Sie Ihren Orlando-Expertenstatus auf die nächste Stufe, indem Sie diese Kapitel abschließen und Spezialisierungsabzeichen verdienen',
    train:
      'Bilden Sie sich weiter, machen Sie mit, und werden Sie zum Experten.',
    showroom: '',
    retain:
      'Glückwunsch zum Abschluss Ihrer Schulung! Sie haben nun Ihre stets verfügbare Ressource freigeschaltet, mit der Sie Ihr Expertenwissen pflegen und den Verkauf fördern können. Nutzen Sie diesen Bereich, um Produktfragen kompetent zu beantworten oder auch direkt eine Verkaufspräsentation durchzuführen – jederzeit, überall und von jedem Gerät aus.',
    promote:
      'Teilen Sie diese Elemente, um Interesse zu wecken und mit Kunden und potenziellen Kunden ins Gespräch zu kommen.',
    sell: 'Beantworten Sie Kundenfragen, und besiegeln Sie den Verkauf wie ein Profi mit detaillierten Ressourcen und zielgerichteter Verkaufsunterstützung.',
    favorites: 'Ihre bevorzugten Inhalte ansehen',
    search: 'Alle Inhalte durchgehen',
    subapps: '',
    maintrainings:
      'Beginnen Sie mit den grundlegenden Fakten zu Orlando und Übernachtungsmöglichkeiten für Ihre Kunden.',
    subtrainings:
      'Schließen Sie diese Module zu all den spannenden Dingen ab, die Kunden in Orlando sehen und unternehmen können, und erhalten Sie Ihr Zertifikat als offizieller Orlando-Experte.',
  },
  general: {
    offerBig:
      'Mit Ihrem Expertenstatus kommen viele Vorteile, beginnend mit exklusiven Angeboten und Rabatten, die nur für Sie verfügbar sind! Klicken Sie auf die Schaltfläche "Angebote" auf der Startseite, um die Früchte Ihrer Bemühungen zu ernten.',
    badge: 'Badge anzeigen',
    offerMessage: 'LEGOLAND Florida Kostenloses Ticket-Angebot',
    unlock:
      'Schalten Sie diesen Gegenstand frei, indem Sie den Lernabschnitt abschließen.',
    next: 'Weiter',
    yes: 'Ja',
    no: 'Nein',
    previous: 'Vorheriges',
    submit: 'Absenden',
    back: 'Zurück',
    close: 'Schließen',
    page: 'Seite',
    search: 'Suche',
    logIn: 'Anmelden',
    logOut: 'Abmelden',
    viewItem: '{type} anzeigen',
    imageNotFound: 'Bild nicht gefunden',
    noResultsFor: 'Es wurden keine Ergebnisse gefunden für: {{query}}',
    noFavorites: 'Sie haben noch keine Favoriten.',
    noMessages: 'Sie haben noch keine Nachrichten erhalten!',
    resultsFor: 'Ergebnisse für: {{query}}',
    showAll: 'Alle anzeigen',
    connectionError: 'Verbindungsfehler',
    alreadyExists: 'Bereits vorhanden',
    pageNotFound: '404 Seite nicht gefunden!',
    oops: 'Tut uns leid ...',
    overview: 'Zurück zur Übersicht',
    complete: 'Fortfahren',
    courseComplete: 'Kapitel abgeschlossen!',
    chapterComplete: 'Kapitel abgeschlossen!',
    message: '{count} Nachricht',
    messagePlural: '{count} Nachrichten',
    completion: 'Schließe die Stiftung ab, um diesen Gegenstand freizuschalten',
  },
  itemTypes: {
    image: 'Bild',
    brochure: 'Sammlung',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Sammlung',
  },
  questions: {
    dials: 'Drehen Sie die Rädchen für die passende Antwort',
    fitb: 'Füllen Sie die Lücke(n)',
    flip: 'Ändern Sie die Zahl für die passende Antwort',
    multipleChoice: 'Wählen Sie die richtige(n) Antwort(en)',
    slider: 'Wählen Sie die richtige Antwort über den Schieberegler',
    map: 'Beantworten Sie die Frage, indem Sie auf die richtige Stelle auf der Karte tippen',
    dropdown: 'Wählen ...',
    true: 'Richtig',
    false: 'Falsch',
  },
  reportCard: {
    download: 'Herunterladen',
    email: 'Per E-Mail senden',
    print: 'Drucken',
  },
  cookies: {
    consent: 'ZUSTIMMEN',
    optout: 'Abwählen',
    settings: 'Datenschutzeinstellungen',
    message:
      'Sie haben noch keine Datenschutzeinstellungen vorgenommen! Das ist nicht schlimm, aber wir möchten Ihnen gerne die beste Erfahrung mit der Verkaufshilfe bieten.',
    disabled:
      'Offensichtlich haben Sie die Verwendung von Cookies deaktiviert.',
    use: '{{appName}} erfordert die Verwendung von Cookies für die beste Benutzererfahrung.',
    details: 'Wofür werden die Cookies verwendet?',
    enable: 'Wie Sie Cookies aktivieren, erfahren Sie {{here}}.',
    here: 'hier',
  },
  notLoggedIn: {
    super: 'Sie sind nicht angemeldet',
    title: 'Sie müssen angemeldet sein, um diesen Inhalt anzuzeigen',
    guest: 'Gast',
  },
  demo: {
    message:
      'Diese Website ist eine Demo der endgültigen Seite. Sie wird derzeit entwickelt und ist noch nicht fertig.',
    consent: 'Verstanden!',
  },
  share: {
    header: 'Teilen Sie diese Ressource in den sozialen Medien!',
    download: 'Herunterladen',
  },
  sharing: {
    copyURL: 'Link kopieren',
    copied: 'Kopiert',
  },
  breadCrumbs: {
    page: 'Seite',
  },
  onMobile: {
    header:
      'Offensichtlich versuchen Sie, über ein Mobilgerät auf {appName} zuzugreifen',
    body: 'Um dieses Programm herunterzuladen, gehen Sie zu unserem App-Store, und suchen Sie nach {appName}, oder klicken Sie auf eine der Schaltflächen unten',
    benefits: {
      1: 'Unterwegs lernen, bewerben und verkaufen',
      2: 'Multimedia-Schulung auf allen Geräten',
      3: 'Abschlusszertifikat',
      4: 'Vorgefertigte Verkaufspräsentationen',
      5: 'Wirkungsvolles Werbematerial',
      6: 'Echtzeit-Produktverzeichnis',
      7: 'Aktuelle Neuigkeiten und Updates',
      header: 'Sie erhalten dann:',
    },
  },
  custom: {
    splitUsers: 'Ich bin ein ...',
    brandAmbassador: 'Markenbotschafter',
    travelPro: 'Reiseexperte',
  },
  directory: {
    attractions: 'Attraktionen',
    hotels: 'Hotels',
    dining: 'Essen',
    nightlife: 'Nachtleben',
    artsculturehistory: 'Kunst, Kultur und Geschichte',
    themeparks: 'Themenparks',
    sportsrecreationoutdoors: 'Sport, Freizeit und Outdoor',
    otheraccommodations: 'Andere Unterkünfte',
    shopping: 'Einkaufen',
    weddingservices: 'Hochzeitsservices',
    medicalservices: 'Medizinische Dienstleistungen',
    golf: 'Golf',
    transportationservices: 'Transportdienstleistungen',
    spas: 'Wellnesszentren',
    filters: 'Filter',
    reset: 'Filter zurücksetzen',
    view: 'Jetzt anzeigen',
    amount: 'Anzahl der Ergebnisse',
    retail: 'Einzelhandel',
    accommodations: 'Unterkünfte',
    transportation: 'Transport',
    conventionservices: 'Konferenzdienstleistungen',
    visitorprofessionalservices:
      'Besucher- und professionelle Dienstleistungen',
    visitorandprofessionalservices:
      'Besucher- und professionelle Dienstleistungen',
    studentandyouthgroupfriendly: 'Studenten- und Jugendgruppenfreundlich',
  },
  search: {
    pages: 'Seiten',
    resources: 'Ressourcen',
  },
};
